/**
 * Format a datetime for sending to server (ISO format in UTC)
 * Converts Stockholm timezone to UTC ISO string.
 *
 * @returns {string|null} ISO string in UTC (e.g., "2024-01-15T14:30:00Z"), or null if date is invalid
 *
 * @example
 * const datetime = window.dayjs.now()
 * datetime.formatDateTimeForServer() // Returns ISO string in UTC
 */
export default (o, c, d) => {
  c.prototype.formatDateTimeForServer = function () {
    if (!this.isValid()) { return null }
    // If already in timezone, convert to UTC. Otherwise, assume Stockholm and convert.
    if (this.tz()) {
      return this.utc().toISOString()
    }
    return this.tz('Europe/Stockholm').utc().toISOString()
  }
}
